<template>
  <div class="home">
    <app-header/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <SidePanel/>
        </div>

        <div class="col-12 col-sm-6 col-md-8 col-lg-9">
          <div class="row">
            <ItemCard v-for="(product, index) in filteredProducts" :key="index" :product="product"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import ItemCard from "@/components/ItemCard.vue";
import SidePanel from "@/components/SidePanel.vue";

import { mapGetters } from "vuex";

export default {
  name: "home",
  components: {
    ItemCard,
    "app-header": Header,
    SidePanel
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("products", ["filteredProducts"])
  }
};
</script>
